
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mexico-import-duty/[importDuty]",
      function () {
        return require("private-next-pages/mexico-import-duty/[importDuty].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mexico-import-duty/[importDuty]"])
      });
    }
  